export default __webpack_public_path__ + "static/media/exterior2.ff1f73bc.jpeg";